// extracted by mini-css-extract-plugin
export default {"uerCopyPagesList":"ProjectCopy_uerCopyPagesList__LlDRV"};